// extracted by mini-css-extract-plugin
module.exports = {"btnRow":"PriceModal_btnRow__4Qey1","btnSubmit":"PriceModal_btnSubmit___bULk","btnClose":"PriceModal_btnClose__D20YQ"};